import NextSwineRecord from './NextSwineRecord';

export default NextSwineRecord;
